/* eslint-disable prettier/prettier */
import React from 'react';

import {
  Upload,
  Input,
  Button,
  DatePicker,
  Select,
  Checkbox,
  message,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getUsuarios from '../../../graphql/querys/auth/getUsuarios.graphql';
import getUsuariosPorOrganismo from '../../../graphql/querys/auth/getUsuariosPorOrganismo.graphql';
import getSucursales from '../../../graphql/querys/organismos/getSucursales.graphql';
import getTipoCertificacionesTraspaso from '../../../graphql/querys/otros/getTipoCertificacionesTraspaso.graphql';

const FormItem = Form.Item;


@compose(
  graphql(getUsuario),
  graphql(getUsuariosPorOrganismo, {
    name: 'getUsuariosPorOrganismo',
    options: (props) => ({
      fetchPolicy: 'network-only',
      variables: {
        idOrganismo: props.idOrganismoOrigen || (props.data && props.data.getUsuario && props.data.getUsuario.organismo._id)
      },
      skip: true
    })
  }),
  graphql(getSucursales, { name: 'getSucursales' }),
  graphql(getOrganismos, { name: 'getOrganismos' }),
  graphql(getTipoCertificacionesTraspaso, { name: 'getTipoCertificacionesTraspaso' })
)
class FormOtrosCertificacionesTraspaso extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: [],
      loaded: false,
    };
  }

  componentDidMount() {
    if (!this.props.onSubmit) {
      console.warn("FormOtrosCertificacionesTraspaso requires an onSubmit prop to function properly");
    }
  }

  onSubmit = e => {
    e.preventDefault();
  
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (values.fechaInico) {
          values.fechaInico = values.fechaInico.toDate();
        }
        if (values.fechaFin) {
          values.fechaFin = values.fechaFin.toDate();
        }
        // Attach the file from state
        if (!this.state.file.length) {
          console.log("🚀 ~ FormOtrosCertificacionesTraspaso ~ this.props.form.validateFieldsAndScroll ~ his.state.file:", this.state.file)
          message.error('Por favor, suba la resolución en PDF');
          return;
        }
        values.resolucion = this.state.file[0];
        console.log("Submitting values:", values);
        if (this.props.onSubmit) {
          //La funcion se llama crearCertificacionTraspaso
          this.props.onSubmit(values);
        } else {
          console.warn("No onSubmit prop provided to FormOtrosCertificacionesTraspaso");
        }
      }
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.data.loading && nextProps.data.getUsuario) {
      const idOrganismo = nextProps.data.getUsuario.organismo._id;
      // this.cambiarOrganismoOrigen(idOrganismo);
    }
  }

  // eslint-disable-next-line no-unused-vars
  onChange = (date, dateString) => {
    this.setState({
      ...this.state,
      fechaInicio: date[0]
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .toDate(),
      fechaFin: date[1]
        .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
        .toDate(),
    });
  };

  cambiarOrganismoOrigen = idOrganismo => {
    // Update state with new organismo selection
    this.setState({
      ...this.state,
      idOrganismoOrigen: idOrganismo,
      nombreOrganismo: this.obtenerNombreOrganismo(idOrganismo),
    }, () => {
      // Refetch users for the new organismo
      console.warn("buscando")
      this.props.getUsuariosPorOrganismo.refetch({
        idOrganismo: idOrganismo
      });
    });
  };

  cambiarOrganismoDestino = idOrganismo => {
    this.setState({
      ...this.state,
      idOrganismoDestino: idOrganismo,
      nombreOrganismo: this.obtenerNombreOrganismo(idOrganismo),
  });
};

  cambiarInteresado = idInteresado => {
    this.setState({
      ...this.state,
      idInteresado: idInteresado
    });
  };

  onChangeTipo = e => {
    this.setState(
      {
        ...this.state,
        tipo: e.target.value,
      },
      () => {
      }
    );
  };

  obtenerNombreOrganismo = idOrganismo => {
    let nombre = '';
    let organismo = _.find(this.props.getOrganismos.getOrganismos, {
      _id: idOrganismo,
    });
    organismo
      ? (nombre = organismo.nombre)
      : (nombre = this.props.data.getUsuario.organismo.nombre);
      return nombre;
    };
    
    obtenerNombreUsuarios = idOrganismo => {
    let usuarios = _.find(this.props.getUsuariosPorOrganismo.getUsuariosPorOrganismo, {
      _id: idOrganismo,
    });
    return usuarios;
  };

  render() {

    const uploadProps = {
      accept: 'application/pdf',
      listType: 'picture',

      beforeUpload: file => {
        const isPDF = file.type === 'application/pdf';
        if (!isPDF) {
          message.error(`${file.name} no es un archivo PDF`);
          return false;
        }
        // TRANSFORMAR ARCHIVO
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
          file.base64 = e.target.result;
          this.setState({ file: [file], loaded: true });
        };

        return false;
      },
      fileList: this.state.file,
      onRemove: file => {
        this.setState({ file: [], loaded: false });
      },
    };

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const { getFieldDecorator } = this.props.form;

    const { data } = this.props;
    if (data.loading) {
      return <Loading />;
    }

    if (!data.getUsuario || !this.props.getOrganismos.getOrganismos) {
      return <Loading />;
    }

    let usuario = this.props.data.getUsuario;

    let listaSucursales = this.props.getSucursales.getSucursales;
    if (listaSucursales) {
      var opciones = _.map(listaSucursales, this.crearOpciones);
    }

    return (
      <div>
        <h3 className="tituloForm">Otras Certificaciones</h3>

        <Form
          onSubmit={this.onSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem {...formItemLayout} label={'Interesado'}>
            {getFieldDecorator('idInteresado', {
              // initialValue: usuario.organismo._id,
              rules: [
                {
                  type: 'string',
                  required: true,
                  message: 'Por favor, seleccione el Interesado',
                },
              ],
            })(
              <Select
                style={{ width: 400, marginRight: 20 }}
                id="interesados"
                placeholder="Seleccione al Interesado"
                loading={this.props.getUsuariosPorOrganismo.loading}
                onChange={valor => this.cambiarInteresado(valor)}
              >
                {this.props.getUsuariosPorOrganismo.getUsuariosPorOrganismo &&
                  this.props.getUsuariosPorOrganismo.getUsuariosPorOrganismo.map(usuario => (
                    <Select.Option key={usuario._id} value={usuario._id}>
                      {usuario.nombre + " " + usuario.apellido}
                    </Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>

          <FormItem {...formItemLayout} label={'Organismo de origen'}>
            {getFieldDecorator('idOrganismoOrigen', {
              initialValue: usuario.organismo._id,
              rules: [
                {
                  type: 'string',
                  required: true,
                  message: 'Por favor, seleccione el organismo de origen',
                },
              ],
            })(
              <Select
                style={{ width: 400, marginRight: 20 }}
                id="organismosOrigen"
                placeholder="Seleccione el organismo origen"
                onSelect={valor => this.cambiarOrganismoOrigen(valor)}
              >
                {this.props.getOrganismos.getOrganismos &&
                  this.props.getOrganismos.getOrganismos.map(organismo => (
                    <Select.Option key={organismo._id}>
                      {organismo.nombre}
                    </Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>

          <FormItem {...formItemLayout} label={'Organismo destino'}>
            {getFieldDecorator('idOrganismoDestino', {
              rules: [
                {
                  type: 'string',
                  required: true,
                  message: 'Por favor, seleccione el organismo de destino',
                },
              ],
            })(
              <Select
                style={{ width: 400, marginRight: 20 }}
                id="organismosDestino"
                placeholder="Seleccione el organismo destino"
                onSelect={valor => this.cambiarOrganismoDestino(valor)}
              >
                {this.props.getOrganismos.getOrganismos &&
                  this.props.getOrganismos.getOrganismos
                    .filter(organismo => organismo.nombre.toUpperCase().includes('PAZ'))
                    .map(organismo => (
                    <Select.Option key={organismo._id}>
                      {organismo.nombre}
                    </Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>

          <FormItem {...formItemLayout} label={'Fecha desde'}>
            {getFieldDecorator('fechaInico', {
              rules: [
                {
                  type: 'object',
                  required: true,
                  message: 'Por favor, seleccione la fecha del fin del certificado',
                },
              ],
            })(<DatePicker placeholder="Fecha desde" format="DD/MM/YYYY" />)}
          </FormItem>
          <FormItem {...formItemLayout} label={'Fecha hasta'}>
            {getFieldDecorator('fechaFin', {
              rules: [
                {
                  type: 'object',
                  required: true,
                  message: 'Por favor, seleccione la fecha de fin de certificado',
                },
              ],
            })(<DatePicker placeholder="Fecha Hasta" format="DD/MM/YYYY" />)}
          </FormItem>
          <FormItem {...formItemLayout} label={'Tipo de Certificacion'}>
            {getFieldDecorator('tipoCertificacionTraspaso', {
              rules: [
                {
                  type: 'string',
                  required: true,
                  message: 'Por favor, seleccione el tipo de certificacion',
                },
              ],
            })(
              <Select
                style={{ width: 400, marginRight: 20 }}
                id="certificacionTraspaso"
                placeholder="Seleccione el tipo de Certificacion"
                // onSelect={valor => this.cambarCertificacion(valor)}
              >
                {this.props.getTipoCertificacionesTraspaso.getTipoCertificacionesTraspaso &&
                  this.props.getTipoCertificacionesTraspaso.getTipoCertificacionesTraspaso.map(certificacion => (
                    <Select.Option key={certificacion._id}>
                      {certificacion.nombre}
                    </Select.Option>
                  ))}
              </Select>
            )}
          </FormItem>

          <FormItem {...formItemLayout} label={'Normativa'}>
            {getFieldDecorator('normativa', {
              rules: [
                {
                  type: 'string',
                  required: true,
                  message: 'Por favor, complete con una normativa',
                },
              ],
            })(
              <Input
                style={{ width: 400, marginRight: 20 }}
                id="normativa"
                placeholder="Ingrese la normativa"
              ></Input>
            )}
          </FormItem>

          <FormItem {...formItemLayout} label={'Pago viáticos'}>
            {getFieldDecorator('pagoViaticos', {
              valuePropName: 'checked',
              initialValue: false,
            })(<Checkbox id="pagoViaticos">¿Corresponde pago de viáticos?</Checkbox>)}
          </FormItem>
          
          <FormItem {...formItemLayout} label={'Observaciones'}>
            {getFieldDecorator('observacionCarga', {
              rules: [
                {
                  type: 'string',
                  message: 'Por favor, ingrese las observaciones',
                },
              ],
            })(
              <Input.TextArea
                style={{ width: 400, marginRight: 20 }}
                id="observacionCarga"
                placeholder="Ingrese las observaciones"
              />
            )}
          </FormItem>


          <FormItem {...formItemLayout} label={'Resolución'}>
            {getFieldDecorator('resolucion', {
              valuePropName: 'fileList',
              getValueFromEvent: e => (Array.isArray(e) ? e : e && e.fileList),
              rules: [
                {
                  required: true,
                  message: 'Por favor, suba la resolución en PDF',
                },
              ],
            })(
            <Upload {...uploadProps} required>
              <Button
                disabled={this.state && (this.state.loaded || this.state.disabledForm)}
              >
                <Icons.UploadOutlined />
                Seleccionar Documento PDF
              </Button>
            </Upload>
            )}
          </FormItem>



          <FormItem {...tailFormItemLayout}>
            <Button
              type="primary"
              onClick={this.onSubmit}
              // htmlType="submit"
              style={{ marginLeft: '25%' }}
            >
              Confirmar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    moment.locale();
    return {
      fechaInicio: Form.createFormField({
        value: moment(),
      }),
    };
  },
})(withApollo(FormOtrosCertificacionesTraspaso));
